import { api_ } from '@shared/plugIn/axios';
import { withoutLoginDeviceId } from '@shared/utils/loginDevice.util';

import {
  Enquiry,
  EnquiryCreate,
  EnquiryUpdate,
  LoginHelpEnquiryDto,
} from './enquiry.interface';

export const createEnquiry = async (enquiryCreateDto: EnquiryCreate) => {
  const { data: enquiry } = await api_.post<Enquiry>('/public/enquiry', enquiryCreateDto);
  return enquiry;
};

export const updateEnquiry = async (enquiryUpdate: EnquiryUpdate, role: string) => {
  const { data: enquiry } = await api_.patch(
    `/${role}/enquiry/${enquiryUpdate._id}`,
    enquiryUpdate,
  );
  return enquiry;
};

/**
 * 로그인 화면의 [문의 남기기] — 로그인 없이 보낸다. Slack 알림 → 관리자 문의 관리 → 답변 시 문자 1회.
 * 400 은 message 를 그대로 보여주면 되고, 429(도배)도 message 가 온다.
 * x-login-device-id 는 axios 인터셉터가 붙인다 (isLoginEndpoint) — 잠김이면 관리자가 그 기기를 바로 찾는다.
 * 고객 화면에서 부르면 `customerSurface` 로 헤더를 뺀다(고객은 기기 잠금 대상이 아니다).
 */
export const createLoginHelpEnquiry = async (
  dto: LoginHelpEnquiryDto,
  options?: { customerSurface?: boolean },
) => {
  const { data } = await api_.post<Pick<Enquiry, '_id' | 'title' | 'status' | 'createdAt'>>(
    '/public/enquiry/login-help',
    dto,
    ...(options?.customerSurface ? [withoutLoginDeviceId()] : []),
  );
  return data;
};
